import { IOverlayClusterParameter } from "@/types/map";
import { graphic } from "echarts";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import { Fill, Stroke, Style, Icon, Text, Circle } from "ol/style";

export default class HighFeauture2D {
  
    private static instances: Map<string, any>;
    private map!: any;
    private constructor(map: any) {
        this.map = map;
    };
    private highMarkLayer!: any;
    
    public static getInstance(map: any){
        let id = map.getTarget();
        console.log(id);
        if (!HighFeauture2D.instances) {
            HighFeauture2D.instances = new Map();
        }
        let intance = HighFeauture2D.instances.get(id);
        if (!intance) {
          intance = new HighFeauture2D(map);
          HighFeauture2D.instances.set(id, intance);
        }
        return intance;
    }

    public static destroy() {
        (HighFeauture2D.instances as any) = null;
    }
    // 点跳跃动画
    public async startup(graphics: any[], params: any, params2: IOverlayClusterParameter) {
        this.highMarkLayer = new VectorLayer({// 设置点位图层
            source: new VectorSource(),
            style: () => {},
        });
        this.highMarkLayer.set("highMarkLayer", this.highMarkLayer);
        this.map.addLayer(this.highMarkLayer);
        this.highMarkLayer.setZIndex(100);
        this.highMarkLayer.getSource().addFeatures(graphics);

        graphics.forEach(graphic =>{
            if (!graphic.getStyle()){//聚合图层
                console.log("聚合图层");
                graphic.setStyle(
                    new Style({
                        image: new Icon({
                            src: graphic.getProperties().symbol.url,
                            anchor: [0.5, 1],
                        //     src: graphic.symbol && graphic.symbol.url ? graphic.symbol.url : (params2 as any).defaultSymbol.url,
                        //     offset: graphic.symbol && graphic.symbol.offset ? graphic.symbol.offset : [0, 0],
                        //     scale: graphic.symbol && graphic.symbol.scale ? graphic.symbol.scale : (params2 as any).defaultSymbol.scale || 0.5,
                        //     opacity: graphic.symbol && graphic.symbol.opacity ? graphic.symbol.opacity : (params2 as any).defaultSymbol.opacity || 1,
                        }),
                    })
                )
            }else {//非聚合图层
                console.log("非聚合图层");
            }
        });
        console.log(this.highMarkLayer.getSource().getFeatures());
        // console.log("进入动画：");
        // console.log(params);
        // graphics.forEach(graphic =>{
        this.highMarkLayer.getSource().getFeatures().forEach((graphic: { getGeometry: () => { (): any; new(): any; translate: { (arg0: number, arg1: number): void; new(): any; }; }; }) =>{
            let randomX = 0;
            let randomY = 0.002;
            let count = 0;
            // 改变点坐标来实现点跳跃效果
            let updatePointPosition = () =>{
                if (count < 6){
                    if (count % 2 == 0){
                        graphic.getGeometry().translate(randomX, randomY);
                    }else if (count % 2 == 1){
                        graphic.getGeometry().translate(randomX, -randomY);
                    };
                }else {
                    clearInterval(animationInterval);
                    this.map.removeLayer(this.highMarkLayer);
                };
                count++;
            };
            updatePointPosition();
            let animationInterval = setInterval(updatePointPosition, 100);
        });
    }
}
